import styles from './Checkbox.module.css';
import * as React from 'react';
import classNames from 'classnames';
import { TaskCategory } from '../../types';
import { TASK_CATEGORY_BG_COLORS } from '../../constants';

type HeaderCheckboxProps = {
  type: TaskCategory
  checked?: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
};

const HeaderCheckbox = ({
  type,
  checked,
  onChange,
  label,
  className,
}: HeaderCheckboxProps) => {
  return (
    <label className={classNames(
      styles['checkbox'],
      'text-xxs uppercase tracking-wide cursor-pointer',
      className,
    )}>
      <input
        type="checkbox"
        checked={checked}
        onChange={({ target }) => onChange(target.checked)}
      />
      <span className="leading-4 select-none pt-px font-bold">{label}</span>
      <div
        className={classNames(
          'w-2 h-2 rounded-sm ml-1 px-1',
          TASK_CATEGORY_BG_COLORS[type],
        )}
      />
    </label>
  );
};

export default HeaderCheckbox;
